import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const motorProposalRef = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'PPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalRef is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.MOTOR) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
